import React, { useState } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheckCircle } from "@fortawesome/free-solid-svg-icons";
import Confetti from "react-confetti";
import config from "../../config"; // Make sure your config file exports an object with backendUrl defined
import "./Subscribe.css"; // Ensure this CSS file is correctly linked

const Subscribe = () => {
  const [email, setEmail] = useState("");
  const [role, setRole] = useState("Select Your Role");
  const [message, setMessage] = useState("");
  const [subscribed, setSubscribed] = useState(false);
  const [showConfetti, setShowConfetti] = useState(false);
  const [fadeOut, setFadeOut] = useState(false);

  const handleSubscribe = async (e) => {
    e.preventDefault();

    // Check if both email and a valid role are provided
    if (!email || role === "Select Your Role") {
      setMessage("Please enter a valid email and select your role.");
      return;
    }

    try {
      const response = await fetch(`${config.backendUrl}/api/add_subscription`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify({ email, role })
      });

      const data = await response.json();
      if (response.ok) {
        setMessage("Success! You’re now subscribed. Expect great updates from us soon!");
        setSubscribed(true);
        setShowConfetti(true);
        setFadeOut(false);

        setTimeout(() => {
          setFadeOut(true);
        }, 2500);

        setTimeout(() => {
          // Reset form and states after animation
          setSubscribed(false);
          setShowConfetti(false);
          setEmail("");
          setRole("Select Your Role");
          setMessage("");
        }, 6000);
      } else {
        // Show error message from the server or a generic one
        setMessage(data.error || "Subscription failed. Please try again.");
      }
    } catch (error) {
      setMessage("Subscription failed due to a network error. Please try again later.");
    }
  };

  return (
    <div className="subscribe-container d-flex justify-content-center align-items-center vh-100">
      {showConfetti && <Confetti numberOfPieces={500} />}
      <div className="subscribe-box text-center p-5 shadow-lg rounded">
        <h2 className="mb-3">Subscribe to Our Updates</h2>
        <p className="text-muted">Stay updated with our latest news and events.</p>
        <form onSubmit={handleSubscribe}>
          <input
            type="email"
            className="form-control mb-3"
            placeholder="Enter your email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
          />
          <select
            className="form-control mb-3"
            value={role}
            onChange={(e) => setRole(e.target.value)}
          >
            <option value="Select Your Role" disabled>
              Select Your Role
            </option>
            <option value="Teacher">Teacher</option>
            <option value="Student">Student</option>
            <option value="Parent">Parent</option>
          </select>
          <button type="submit" className="btn btn-primary w-100 subscribe-btn">
            Subscribe
          </button>
        </form>
        {message && (
          <p
            className={`mt-3 ${
              subscribed ? "text-success animated-check" : "text-danger"
            } ${fadeOut ? "fade-out" : ""}`}
          >
            {subscribed && <FontAwesomeIcon icon={faCheckCircle} className="me-2" />}
            {message}
          </p>
        )}
      </div>
    </div>
  );
};

export default Subscribe;
